<div class="card-container">
  <div class="card-content">
    <h1 class="title">¡Gracias por acompañarnos!</h1>
    <p class="names">Lili & Oscar</p>
  </div>
</div>